import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['previewImg', 'caption', 'hex', 'power'];

  change(event) {
    const el = event.currentTarget;
    const slug = el.value;
    const hex = el.dataset.hex || '';
    const power = el.dataset.power || '';
    if (this.hasPreviewImgTarget) {
      this.previewImgTarget.src = `/avatars/${slug}.png`;
      this.previewImgTarget.parentElement.style.background = `color-mix(in oklch, ${hex} 18%, var(--card))`;
    }
    if (this.hasCaptionTarget) {
      this.captionTarget.textContent = `${slug.charAt(0).toUpperCase()}${slug.slice(1)} mage`;
    }
    if (this.hasHexTarget) this.hexTarget.textContent = hex;
    if (this.hasPowerTarget) this.powerTarget.textContent = power;
  }
}
